<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

  <div class="w-full p-2 flex-1">
    <!-- Boutons et contenu ici -->
    <div class="mx-auto max-w-2xl w-full p-2 flex flex-col justify-center">
      <button *ngIf="!showDivisionOptions" (click)="onCancel()"
        class="bg-white w-full font-bold text-lg p-4 shadow-md rounded-full">Retour</button>
      <button *ngIf="showDivisionOptions" (click)="showDivisionOptions = false"
        class="bg-white w-full font-bold text-lg p-4 shadow-md rounded-full">Retour</button>
    </div>
    <div class="mx-auto max-w-2xl w-full p-2 flex flex-col justify-center gap-2">
      <div *ngIf="!showDivisionOptions; else divisionOptions">
        <button (click)="showDivisionOptions = true"
          class="w-full text-white font-bold text-lg p-4 bg-[#4d47dc] shadow-md rounded-full">
          Division
        </button>
      </div>

      <ng-template #divisionOptions>
        <button (click)="onSelect('partage')"
          class="w-full text-white font-bold text-lg p-4 bg-[#4d47dc] shadow-md rounded-full">
          Diviser l'addition
        </button>
        <button (click)="onSelect('share-items')"
          class="w-full text-white font-bold text-lg p-4 bg-[#4d47dc] shadow-md rounded-full">
          Partager les articles
        </button>
      </ng-template>

      <button *ngIf="!showDivisionOptions" (click)="onSelect('select-items')"
        class="w-full text-white font-bold text-lg p-4 bg-[#4d47dc] shadow-md rounded-full">
        Sélectionner des articles
      </button>

      <button *ngIf="!showDivisionOptions" (click)="onSelect('free-amount')"
        class="w-full text-white font-bold text-lg p-4 bg-[#4d47dc] shadow-md rounded-full">
        Montant libre
      </button>
    </div>
  </div>
</app-dialog-wrapper>